$(document).ready(function () {
	const $searchInput = $('#price-list-search, #price-list-earch').first();
    const $priceListTable = $('.price-list-table').first();

    if (!$searchInput.length || !$priceListTable.length) {
        return;
    }

    const $categories = $priceListTable.find('.price-list-table-category');

	$priceListTable.find('[data-search-term]').each(function () {
		const $el = $(this);
		const normalized = normalizeSearchTerm($el.attr('data-search-term'));
		$el.attr('data-search-term', normalized);
	});

	function setAccordionState($category, shouldOpen, animate) {
		const $trigger = $category.find('.accordion-trigger').first();
		if (!$trigger.length) {
			return;
		}

		if (typeof window.setAccordionTriggerState === 'function') {
			window.setAccordionTriggerState($trigger, shouldOpen, animate);
			return;
		}

		const target = $trigger.data('target');
		const $target = $('#' + target);
		$trigger.toggleClass('open', shouldOpen);

		if (!$target.length) {
			return;
		}

		if (animate) {
			if (shouldOpen) {
				$target.stop(true, true).slideDown(200);
			} else {
				$target.stop(true, true).slideUp(200);
			}
		} else if (shouldOpen) {
			$target.show();
		} else {
			$target.hide();
		}
	}

	let debounceTimer = null;

	$searchInput.on('input', function () {
		const value = $(this).val();

		if (debounceTimer) {
			clearTimeout(debounceTimer);
		}

		debounceTimer = setTimeout(function () {
			filterPriceList(value);
		}, 300);
	});

    function filterPriceList(rawQuery) {
        const query = normalizeSearchTerm(rawQuery);

        if (!query) {
            $categories.each(function () {
                const $category = $(this);
                $category.stop(true, true).slideDown(200);
                $category.find('tr[data-search-term]').show();
                setAccordionState($category, false, true);
            });
            return;
        }

        let matchedByCategoryTitle = false;
        const tableMatches = [];

        $categories.each(function () {
            const $category = $(this);
            const categoryTerm = $category.attr('data-search-term') || '';
            const isCategoryMatch = categoryTerm.indexOf(query) !== -1;

            if (isCategoryMatch) {
                matchedByCategoryTitle = true;
            }

            let hasTableMatch = false;

            $category.find('tr[data-search-term]').each(function () {
                const $row = $(this);
                const rowTerm = $row.attr('data-search-term') || '';
                const rowMatch = rowTerm.indexOf(query) !== -1;
                $row.toggle(rowMatch || isCategoryMatch);

                if (rowMatch) {
                    hasTableMatch = true;
                }
            });

            const shouldShowCategory = isCategoryMatch || hasTableMatch;

            if (shouldShowCategory) {
                $category.stop(true, true).slideDown(200);
            } else {
                $category.stop(true, true).slideUp(200);
            }

            tableMatches.push({
                category: $category,
                hasTableMatch: hasTableMatch,
                isCategoryMatch: isCategoryMatch
            });
        });

        if (matchedByCategoryTitle) {
            $categories.each(function () {
                setAccordionState($(this), false, true);
            });
            return;
        }

        tableMatches.forEach(function (entry) {
            setAccordionState(entry.category, entry.hasTableMatch, true);
        });
    }
});

function normalizeSearchTerm(value) {
    return String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '');
}